// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"App_mainContainer__1H8Fp"};